import { lazy } from "react";

const KEY = "rosterly_chunk_reload";
export const isChunkError = (e) => /ChunkLoadError|Loading chunk|Loading CSS chunk|dynamically imported module|Unexpected token '<'|SyntaxError/i.test(`${e?.name} ${e?.message}`);

// After a redeploy an open tab asks for old route files that no longer exist -> reload once to pick up the new build.
export const reloadOnce = () => {
    const last = Number(sessionStorage.getItem(KEY) || 0);
    if (Date.now() - last < 10000) return false;
    sessionStorage.setItem(KEY, String(Date.now()));
    window.location.reload();
    return true;
};

export const lazyReload = (factory) => lazy(() => factory().catch((e) => {
    if (isChunkError(e) && reloadOnce()) return new Promise(() => {});
    throw e;
}));
